var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentsInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14118",
    "data-name": "Group 14118",
    transform: "translate(-808 -4053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14111",
    "data-name": "Group 14111",
    transform: "translate(-469 -1368)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 43,
    height: 40,
    rx: 12,
    transform: "translate(1277 5421)",
    fill: "#3488eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "credit-card-payment-svgrepo-com",
    transform: "translate(817 4060.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14110",
    "data-name": "Group 14110",
    transform: "translate(0 3.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5248",
    "data-name": "Path 5248",
    d: "M23.907,3.12,9.743,3.128A1.471,1.471,0,0,0,8.272,4.6v.675a2.856,2.856,0,0,0-1.15-.221,4.453,4.453,0,0,0-1.144.151.782.782,0,0,0-.309.167L.27,10.1a.8.8,0,0,0-.27.618l.047,7.786a.939.939,0,0,0,.9.772c.021,0,2.035.084,3.814.084a20.872,20.872,0,0,0,2.338-.09,3.782,3.782,0,0,0,2.3-.867c.268-.2.506-.388.754-.581A1.686,1.686,0,0,0,13,19.452a1.721,1.721,0,0,0,.6.518,1.742,1.742,0,0,0,.764.181,1.684,1.684,0,0,0,1.506-.927l1.12-2.2a1.675,1.675,0,0,0,.106-1.291,1.617,1.617,0,0,0-.2-.389l7.008,0a1.477,1.477,0,0,0,1.475-1.471l.005-9.262A1.485,1.485,0,0,0,23.907,3.12ZM13.473,16.352l-1.117,2.207a.633.633,0,1,1-1.13-.571l.919-1.81s.3-.734.781-.742a.62.62,0,0,1,.27.067.627.627,0,0,1,.314.367A.608.608,0,0,1,13.473,16.352Zm-1.76-1.941-1.01.926h.009c-.633.548-1.386,1.157-2.313,1.842a.355.355,0,0,0-.124.115,2.714,2.714,0,0,1-1.366.407c-.289.036-.894.031-2.144.031-1.087,0-2.441.016-3.181-.009L1.6,11.052,6.564,6.7a3.065,3.065,0,0,1,.558-.055.953.953,0,0,1,.667.177v5.506a.793.793,0,0,0,.388.681c.028.016.06.013.09.027v.059l.074-.037a.761.761,0,0,0,.621-.031,14.65,14.65,0,0,1,4.593-1.732.65.65,0,0,1,.111.005.127.127,0,0,0,.013.023C13.7,11.425,13.8,12.343,11.712,14.411Zm4.325,2.125L14.92,18.743a.645.645,0,0,1-.852.28.635.635,0,0,1-.277-.851l1.118-2.207a.631.631,0,0,1,.564-.349.639.639,0,0,1,.288.071.622.622,0,0,1,.314.365A.611.611,0,0,1,16.037,16.536Zm8.356-2.669a.49.49,0,0,1-.491.491l-10,0a5.463,5.463,0,0,0,1.364-2.7,1.813,1.813,0,0,0-.261-1.213A1.5,1.5,0,0,0,13.554,9.7a12.113,12.113,0,0,0-4.179,1.332v-2.2l15.019,0Zm0-7.947L9.252,5.914V4.6a.49.49,0,0,1,.49-.491L23.907,4.1A.509.509,0,0,1,24.4,4.6Z",
    transform: "translate(0 -3.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5249",
    "data-name": "Path 5249",
    d: "M18.384,11.179l-.011-1.331-3.878,0,.012,1.334Z",
    transform: "translate(4.894 -0.849)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsInvoice);
export default __webpack_public_path__ + "static/media/payments-invoice.7ad9b8c5917e140d2b546c318237b8a2.svg";
export { ForwardRef as ReactComponent };